import React from 'react'
import './AppShowcase.css'
import SectionLabel from '../../components/SectionLabel/SectionLabel';
import AppCard, { THEME_DARK } from '../../components/AppCard/AppCard';
import minesweeperPromo from '../../assets/minesweeper_promo.png'
import sudokuPlusPromo from '../../assets/sudoku_plus_promo.png'
import visualMemoryPromo from '../../assets/visual_memory_promo.png'
import logoQuizPromo from '../../assets/logo_quiz_promo.png'
import flagQuizPromo from '../../assets/flag_quiz_promo.png'
import nonogramPromo from '../../assets/nonogram_promo.png'
import killerSudokuPromo from '../../assets/killer_sudoku_promo.png'
import hidatoPromo from '../../assets/hidato_promo.png'
import kakuroPromo from '../../assets/kakuro_promo.png'
import mathdokuPromo from '../../assets/mathdoku_promo.png'
import schulteTablePromo from '../../assets/schulte_table_promo.png'

const AppsShowcase = () => {

    const appsInfo = {
        minesweeper: {
            color: "#BDBDBD",
            image: minesweeperPromo,
            title: "Minesweeper",
            android: "https://play.google.com/store/apps/details?id=com.netiapp.minesweeper",
            description: "Minesweeper is a single-player puzzle video game. The objective of the game is to clear a board containing hidden bombs without detonating any of them."
        },
        sudokuPlus: {
            color: "#626BA8",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.netiapps.sudokuplus",
            image: sudokuPlusPromo,
            title: "Sudoku+",
            description: "Sudoku is a popular logic number puzzle, Special kinds included Hyper sudoku, Diagonal Sudoku with daily puzzles and more..."
        },
        visualMemory: {
            color: "#4A86E8",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.NETI.MemoryTraining",
            web: "https://visualmemory.web.app/",
            image: visualMemoryPromo,
            title: "Visual Memory",
            description: "Train memory to improve concentration & cognitive function with this simple game."
        },
        logoQuiz: {
            color: "#FAF9F9",
            android: "https://play.google.com/store/apps/details?id=logoquiz.netiapps.com.logoquiz",
            image: logoQuizPromo,
            title: "Logo Quiz",
            description: "Ultimate trivia game, Test your knowledge with your friends and family!"
        },
        flagQuiz: {
            color: "#EEEEEE",
            android: "https://play.google.com/store/apps/details?id=com.netiapps.flagquiz",
            image: flagQuizPromo,
            title: "Flag Quiz",
            description: "Can you guess all the flags?"
        },
        nonogram: {
            color: "#4EC2BB",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.netiapps.nonogram",
            image: nonogramPromo,
            title: "Nonogram",
            description: "Nonogram \"The puzzle of art\" is pictures puzzle game , The rules are simple - color by the numbers on the side to reveal a picture!"
        },
        killerSudoku: {
            color: "#262F56",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.netiapps.sudokukiller",
            apple: "https://apps.apple.com/us/app/id1530209080",
            image: killerSudokuPromo,
            title: "Killer Sudoku",
            description: "Killer sudoku is a puzzle that combines elements of Sudoku and Kakuro, One of the hardest puzzle challenges!"

        },
        hidato: {
            color: "#3E2525",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.netiapps.hidato",
            image: hidatoPromo,
            title: "Hidato",
            description: "Hidato is a logic based numbers puzzle, The goal of Hidato is to fill the grid with consecutive numbers."

        },
        kakuro: {
            color: "#6E2046",
            theme: THEME_DARK,
            android: "https://play.google.com/store/apps/details?id=com.netiapps.kakuro",
            image: kakuroPromo,
            title: "Kakuro",
            description: "Kakuro is a kind of logic puzzle that is often referred to as a mathematical transliteration of the crossword."

        },
        mathdoku: {
            color: "#96FF94",
            android: "https://play.google.com/store/apps/details?id=com.netiapps.kenken",
            image: mathdokuPromo,
            title: "MathDoku",
            description: "Another hard puzzle , ready to become an expert?"
        },
        schulteTable: {
            color: "#DDDDDD",
            web: "https://schultetable.web.app/",
            image: schulteTablePromo,
            title: "Schulte Table",
            description: "Improve fast reading & attention"
        },
    }

    const apps = ["minesweeper", "sudokuPlus", "nonogram","logoQuiz", "visualMemory", "flagQuiz", "killerSudoku", "hidato", "kakuro", "mathdoku", "schulteTable"]


    return (
        <div id="apps">
            <div className="apps-show-case-container">
                <SectionLabel label="Our Apps" />
                <div className="app-card-collection">
                    {apps.map((appName) => <AppCard key={appName} {...appsInfo[appName]} />)}
                </div>

            </div>
        </div>
    )
}

export default AppsShowcase
